// extracted by mini-css-extract-plugin
export default {"sectionDescription":"style_sectionDescription__lRsgi"};